export { Chip } from './Chip';
export type { ChipProps } from './Chip';
